import { Controller } from "@hotwired/stimulus"

// Displays selected filename in file upload areas
export default class extends Controller {
  static targets = ["input", "placeholder", "filename", "icon"]

  connect() {
    this.updateDisplay()
  }

  select() {
    this.inputTarget.click()
  }

  changed() {
    this.updateDisplay()
  }

  updateDisplay() {
    const file = this.inputTarget.files[0]
    
    if (file) {
      // Show filename, hide placeholder
      const filenameText = this.filenameTarget.querySelector("p:first-child")
      if (filenameText) {
        filenameText.textContent = file.name
      }
      this.filenameTarget.classList.remove("hidden")
      this.placeholderTarget.classList.add("hidden")
      
      // Update icon to show success
      if (this.hasIconTarget) {
        const svg = this.iconTarget.querySelector("svg")
        if (svg) {
          svg.classList.remove("text-gray-400")
          svg.classList.add("text-green-500")
        }
      }
    } else {
      // Show placeholder, hide filename
      this.filenameTarget.classList.add("hidden")
      this.placeholderTarget.classList.remove("hidden")
      
      // Reset icon
      if (this.hasIconTarget) {
        const svg = this.iconTarget.querySelector("svg")
        if (svg) {
          svg.classList.add("text-gray-400")
          svg.classList.remove("text-green-500")
        }
      }
    }
  }

  // Handle drag and drop
  dragover(event) {
    event.preventDefault()
    this.element.classList.add("border-blue-500", "bg-blue-50")
  }

  dragleave(event) {
    event.preventDefault()
    this.element.classList.remove("border-blue-500", "bg-blue-50")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("border-blue-500", "bg-blue-50")
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.updateDisplay()
    }
  }
}
